import React from 'react';
import { useRouteMatch, useParams } from 'react-router-dom';
import { observer } from 'mobx-react';

import { useDataStore } from 'state/DataStore';
import Sidebar from 'components/sidebar/Sidebar';
import SidebarLink from 'components/sidebar/SidebarLink';
import joinPath from 'utilities/joinPath';

const UnitSidebar = observer(() => {
    const match = useRouteMatch();
    const { unitSlug } = useParams();
    const dataStore = useDataStore();
    
    const unit = dataStore.getItem('units', 'slug', unitSlug);
    const unitType = dataStore.getItem('unit_types', 'id', unit?.acf?.unit_type);
    
    
    const walkthrough = unitType?.acf?.walkthrough_url ? [{ slug: 'walk-through', name: 'Walk Through' }] : [];
    
    const subpages = [
        { slug: 'floorplan', name: 'Floorplan' },
        { slug: 'features', name: 'Features' },
        ...walkthrough,
        // { slug: 'render-gallery', name: 'Gallery' },
        // { slug: 'colour-schemes', name: 'Colour Schemes' }
    ];
    
    return (
        <Sidebar>
            <SidebarLink
                key="back"
                to={match.url.replace(`/${unitSlug}`, '')}
                text="← Back"
                exact={true}
            />
            
            {subpages.map(({ slug, name }) => (
                <SidebarLink
                    key={slug}
                    to={joinPath(match.url, slug)}
                    text={name}
                />
            ))}
        </Sidebar>
    );
});

export default UnitSidebar;